import { memo } from 'react'
import { Stack, Text } from 'ui/baseComponents'
import BrandedSectionHeader from 'ui/clinicianScreens/Patient/Report/components/BrandedSectionHeader'
import ReportTitle from 'ui/clinicianScreens/Patient/Report/components/ReportTitle'
import { formatDates } from 'ui/clinicianScreens/Patient/Report/components/ReportPeriods/helpers'
import { colors } from 'theme/colors'
import { useReportTranslation } from 'utilities/i18n'

const ReportPeriods = ({
  clinicalVisitId,
  startDate,
  endDate,
  prevStartDate,
  prevEndDate,
  variant,
  comparisonLayout = false,
}) => {
  const { t, formatDate } = useReportTranslation()
  const STYLES = {
    square: {
      width: '16px',
      height: '16px',
    },
    periodContainer: {
      flex: 1,
    },
    periodDatesRow: {
      marginTop: '16px !important',
    },
  }

  const formattedDates = formatDates({
    startDate,
    endDate,
    prevStartDate,
    prevEndDate,
    formatDate,
  })

  const Square = ({ backgroundColor }) => (
    <div style={{ ...STYLES.square, backgroundColor }} />
  )

  // Comparison layout for pre-visit or clinical visit reports
  if (clinicalVisitId || comparisonLayout) {
    return (
      <>
        <BrandedSectionHeader
          {...{
            title: t('report.periods.comparison'),
            variant,
          }}
        />
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          sx={STYLES.periodDatesRow}
          data-cy="report-periods"
        >
          <ReportTitle justifyContent="center" sx={STYLES.periodContainer}>
            <Square backgroundColor={colors.PRIMARY[1000]} />
            <Text variant="body16">
              {t('report.periods.recent')}
              {formattedDates.startDate} - {formattedDates.endDate}
            </Text>
          </ReportTitle>
          <ReportTitle justifyContent="center" sx={STYLES.periodContainer}>
            <Square backgroundColor={colors.PRIMARY[700]} />
            <Text variant="body16">
              {t('report.periods.previous')}
              {formattedDates.prevStartDate} - {formattedDates.prevEndDate}
            </Text>
          </ReportTitle>
        </Stack>
      </>
    )
  }

  return (
    <ReportTitle justifyContent="center">
      <Text
        variant="body16B"
        color={colors.PRIMARY[1000]}
        data-cy="report-period-dates"
      >
        {t('report.periods.recent')}
        {formattedDates.startDate} - {formattedDates.endDate} |{' '}
        {t('report.periods.previous')}
        {formattedDates.prevStartDate} - {formattedDates.prevEndDate}
      </Text>
    </ReportTitle>
  )
}

export default memo(ReportPeriods)
